import {systemBlack} from "../../constants";
import {motion} from "framer-motion";
import { createStyledElement } from "../../../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const ContactTitle = createStyledElement("span", {
  font: '700 16px/18px "Roboto", sans-serif',
  color: systemBlack,
});

export const ContactsSectionContent = createStyledElement(motion.section, () => ({
  padding: isMobileViewport() ? "30px 16px" : "50px 40px",
  backgroundColor: "#FAFBFF",
  overflow: "hidden",
}));

export const ContactsSectionContainer = createStyledElement("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexDirection: "column",
  marginTop: 50,
  width: "100%",
});

export const ContactsContent = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  marginTop: 20,
  gap: isMobileViewport() ? 10 : 50,
  flexDirection: isMobileViewport() ? "column" : "row",
  width: "100%",
}));

export const ContactsBlock = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: isMobileViewport() ? 10 : 15,
  width: "100%",
  flexWrap: "wrap",
}));

export const Pane = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: 5,
  minWidth: 0,
  width: isMobileViewport() ? "100%" : undefined,
  maxWidth: "100%",
}));
